import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import useDebounce from './useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import { FaMapMarkerAlt } from "react-icons/fa";
import Breadcrumb from '../components/Breadcrumb';
import { useSelector } from 'react-redux';

const BranchList = () => {
  const formFields = { name: '', address: '', companyId: '', collectionCenterId: '', type: '', code: '', number: '', url: '' };

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [branchForm, setBranchForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [collectionCenterList, setCollectionCenterList] = useState([]);
  const [query, setQuery] = useState('');
  const clickToDownload = useRef(null);
  const [locationType, setLocationType] = useState('');
  const [companyList, setCompanyList] = useState([]);
  const [company, setCompany] = useState('');

  const permissions = useSelector((state) => state.permission.permissions);

  const handleShow = () => {
    setShowConfirmModel(true);
    setBranchForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleView = (e, id) => {
    e.preventDefault();
    try {
      get('/branches/?id=' + id).then((branch) => {
        if (branch.data.rows.length) {
          const branchData = branch.data.rows[0];
          setBranchForm(branchData);
          setShowConfirmModel(true);
        } else {
          toast.error('No branch found with this name');
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  // const handleEdit = (e, id) => {
  //   e.preventDefault();
  //   try {
  //     get('/branches/?id=' + id).then(branch => {
  //       if (branch.data.rows.length) {
  //         const branchData = branch.data.rows[0];
  //         setBranchForm(branchData)
  //         setShowConfirmModel(true);
  //       } else {
  //         toast.error('No branch found with this name')
  //       }
  //     })
  //   }
  //   catch (error) {
  //     toast.error(error?.response?.data?.data?.rows?.message || "Something went wrong")
  //   }
  // };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setBranchForm({ ...branchForm, [name]: value });
  };

  // const handleRemove = (event, id) => {
  //   event.preventDefault();
  //   try {
  //     destroy('/branches/' + id).then(response => {
  //       toast.success("Branch Deleted successfully");
  //       setDeleteModel(false);
  //       getBranches();
  //     })
  //   }
  //   catch (err) {
  //     toast.error(err.message, { autoClose: 3000 });
  //   }
  // }

  // const handleConfirmDeleteModal = (e, id) => {
  //   e.preventDefault();
  //   setDeleteModel(true);
  //   setIdToDeleted(id);
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if ('id' in branchForm) {
      // try {
      //   await put(branchForm, '/branches/' + branchForm.id)
      //   toast.success("Branch updated successfully");
      //   setShowConfirmModel(false);
      //   getBranches();
      // } catch (err) {
      //   toast.error(err.message, { autoClose: 3000 });
      // }
    } else {
      try {
        await post(branchForm, '/branches/');
        toast.success('Branch added successfully');
        setShowConfirmModel(false);
        getBranches();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  const getBranches = () => {
    try {
      get(`/branches/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}&type=${locationType}&companyId=${company}`).then(
        (response) => {
          setBranchList(response.data.rows);
          setTotalRecords(response.data.count);
        }
      );
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  function getCollectionDropdown() {
    get('/collection-centers').then((response) => {
      setCollectionCenterList(response.data.rows);
    });
  }

  function getCompanyDropdown() {
    try {
      get('/companies').then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getBranches();
      }
    },
    [query, locationType, company],
    DEBOUNCE_DELAY
  );

  function excelReport() {
    try {
      get(`/branches/?conditionType=download`).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  const setActiveStatus = (e, locationId) => {
    e.preventDefault();
    try {
      put({ isActive: e.target.value }, '/branches/' + locationId).then((response) => {
        toast.success('Activity Status Updated');
        getBranches();
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    getCollectionDropdown();
    getCompanyDropdown();
  }, []);

  useEffect(() => {
    getBranches();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Settings' },
          { link: '#', title: 'Locations' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Locations | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Select
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              className="input"
              style={{ width: '200px', marginRight: '20px' }}
            >
              <option value="">Select Company</option>
              {companyList.map((company) => {
                return (
                  <option key={company?.id} value={company?.id}>
                    {company?.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Select
              value={locationType}
              onChange={(e) => setLocationType(e.target.value)}
              className="input"
              style={{ width: '200px', marginRight: '20px' }}
            >
              <option value="">Select Location Type</option>
              <option value="office">Office</option>
              <option value="factory">Factory</option>
              <option value="outlet">Outlet</option>
              <option value="staff-room">Staff Room</option>
            </Form.Select>
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by location name, number"
              style={{ width: '270px', marginRight: '20px' }}
            />
            <GrDocumentExcel title="Download locations" className="react-icons green" onClick={excelReport} />
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            {permissions.includes('add_location') && (
              <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
                Add Location
              </button>
            )}
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Location Name</th>
                    <th>Number</th>
                    <th>Type</th>
                    <th>Code</th>
                    <th>Address</th>
                    <th>Collection Center</th>
                    <th>Company</th>
                    <th>isActive</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {branchList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.name}</td>
                        <td>{item?.number}</td>
                        <td style={{ textTransform: 'capitalize' }}>{item?.type}</td>
                        <td>{item?.code}</td>
                        <td>{item?.address}</td>
                        <td>{item?.CollectionCenter?.name || '-'}</td>
                        <td>{item?.Company?.name}</td>
                        <td>
                          <select value={item?.isActive} onChange={(e) => setActiveStatus(e, item?.id)}>
                            <option value={true}>Active</option>
                            <option value={false}>inActive</option>
                          </select>
                        </td>
                        <td className="actions">
                          <div className="d-flex">
                            <Link onClick={(e) => handleView(e, item?.id)}>
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                            {item?.url && (
                              <a href={item?.url} target="_blank" rel="noopener noreferrer">
                                <FaMapMarkerAlt title="Go to map" className="react-icons" color='dodgerblue' />
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title> {'id' in branchForm ? 'Location Details' : 'Add Location'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Location Name" className="mb-3">
                  {'id' in branchForm ? (
                    <Form.Control disabled className="input" value={branchForm.name} placeholder="Location Name" />
                  ) : (
                    <Form.Control
                      className="input"
                      value={branchForm.name}
                      name="name"
                      onChange={handleChange}
                      type="text"
                      placeholder="Branch Name"
                      required
                    />
                  )}
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Location Code" className="mb-3">
                  <Form.Control
                    disabled={'id' in branchForm}
                    className="input"
                    value={branchForm.code}
                    name="code"
                    onChange={handleChange}
                    type="text"
                    placeholder="Location Code"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Location Number" className="mb-3">
                  <Form.Control
                    disabled={'id' in branchForm}
                    className="input"
                    value={branchForm.number}
                    name="number"
                    onChange={handleChange}
                    type="text"
                    placeholder="Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Address" className="mb-3">
                  <Form.Control
                    disabled={'id' in branchForm}
                    className="input"
                    value={branchForm.address}
                    name="address"
                    onChange={handleChange}
                    type="text"
                    placeholder="Address"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Location Type" className="mb-3">
                  <Form.Select
                    disabled={'id' in branchForm}
                    className="input"
                    value={branchForm.type}
                    name="type"
                    onChange={handleChange}
                    placeholder="Location Type"
                    required
                  >
                    <option value="">Select Location Type</option>
                    <option value="office">Office</option>
                    <option value="factory">Factory</option>
                    <option value="outlet">Outlet</option>
                    <option value="staff-room">Staff Room</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={6} className={branchForm.type === 'outlet' ? '' : 'd-none'}>
                <FloatingLabel controlId="floatingInput" label="Collection Center" className="mb-3">
                  <select
                    disabled={'id' in branchForm}
                    name="collectionCenterId"
                    value={branchForm.collectionCenterId}
                    onChange={handleChange}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option value="">Select Collection Center</option>
                    {collectionCenterList.map((item) => {
                      return (
                        <option key={item?.id} value={item.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <select
                    disabled={'id' in branchForm}
                    name="companyId"
                    value={branchForm.companyId}
                    onChange={handleChange}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option>Select Company</option>
                    {companyList.map((item) => {
                      return (
                        <option key={item?.id} value={item.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </FloatingLabel>
              </Col>
            </Row>
            {'id' in branchForm ? (
              ''
            ) : (
              <div className="container text-center">
                <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
                  Add
                </Button>
              </div>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      {/* <Modal
        size="sm"
        show={deleteModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Branch Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="alert icon" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={() => setDeleteModel(false)} className="btn app-btn-default btn-sm">Cancel</button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">Delete</button>
          </div>
        </Modal.Footer>
      </Modal> */}
    </React.Fragment>
  );
};

export default BranchList;
